// Single data access point for the Command Center.
// Firestore reads/writes go DIRECTLY through the Firebase Web SDK as the
// signed-in ops user (published security rules already grant ops access).
// This keeps all data pages live and resilient — independent of the backend
// admin proxy's Firebase CLI token, which Google periodically invalidates
// (invalid_rapt). The backend proxy is still used only for operations the
// client SDK cannot do: Cloud Functions health, and field onboarding writes
// / Storage uploads via /api/onboarding/*.
import { firebaseAdapter } from "./adapters/firebaseAdapter";

export const adapter = firebaseAdapter;
export const ADAPTER_MODE = "firebase";
